import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGameMyst} from "./base/BaseGameMyst";
import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
import {gsap, SplitText} from "../libs/gsap/all.js";
import FontFaceObserver from '../libs/fontfaceobserver.js';
import {MystMQTT} from "./MystMQTT";
import {Howl} from "howler";
import nunjucks from "/js/libs/nunjucks.js"
import {Timer} from "./components/Timer";
import {GameHarpon} from "./minigames/GameHarpon";

// Constructor
export class MystHarpon extends BaseGameMyst {

  constructor() {

    // Super constructor
    super(`data/myst_harpon_global.json`);
    this.queteId = "harpon";

    // Object class
    this.playlist = new AudioPlaylist();
    this.screenSaverTimer = new Timer();

    this.endingScreenTimer = new Timer();
    this.endingRedirectTimeout = false;

    this.buttonIsLocked = true;

    // Animation timeline
    this.currentTimeline = null;

    this.waitingForRFIDScan = false;

    // GSAP Config
    gsap.config({
      nullTargetWarn: false,
    });

    // Pixi game
    this.game = null;

    // Wait for all
    Promise.all([
      this.loadSettings(),
      this.loadData()
    ]).then(() => {
      // Preload audio files
      return this.preloadAudio();
    }).then(() => {
      // Preload fonts
      return this.preloadFont();
    }).then(() => {
      // Ini nunjucks
      return this.initNunjucks();
    }).then(() => {
      // Replace strings {{ }}
      return this.renderNunjucks();
    }).then(() => {
      // Init pixi games for current Quest
      return this.initMinigame();
    }).then(() => {
      // Convert IMG to inline SVG
      return window.convertSVGToInline();
    }).then(() => {
      // Init MQTT connection
      return this.initMQTT();
    }).then(() => {
      // Real game init
      return this.initGame();
    }).then(() => {
      // Real game init
      return this.initEvents();
    }).catch((error) => {
      console.error("error", error)
      $("#main").append("<div id='error'>Error: " + error.message + "</div>")
    });
  }

  preloadFont() {
    const fonts = [
      new FontFaceObserver("Sketchnote Dingbats", {weight: 400}),
      new FontFaceObserver("Sketchnote Text", {weight: 400, style: "normal"}), // normal
      new FontFaceObserver("Sketchnote Text", {weight: 400, style: "italic"}), // italic
      new FontFaceObserver("Sketchnote Text", {weight: 700, style: "normal"}), // bold
      new FontFaceObserver("Sketchnote Square", {weight: 400}),
    ];

    // Load each observer, then return promise
    let observers = [];
    for (let i = 0; i < fonts.length; i++) {
      observers.push(fonts[i].load());
    }

    return Promise.all(observers);
  }

  initMinigame() {

    return new Promise((resolve, reject) => {

      const initPromises = [];

      console.log(this.data);
      this.game = new GameHarpon(this.data.game);

      this.currentQuestBaseStationRFID = this.data.currentQuestBaseStationRFID

      const initPromise = this.game.init($("canvas#gameHarpon")[0])
        .then(() => this.game.assetLoader())
        .then(() => this.game.buildStage())
        .then(() => {
          this.game.canvas.addEventListener("webglcontextlost", (event) => {
            this.restartApp();
          }, false)
        })

      initPromises.push(initPromise);

      // Resolve all init Promises before resolving main Promise
      Promise.all(initPromises).then(() => resolve()).catch(reject)
    });
  }

  // To be overridden in child games
  initGame() {

    // TODO: Complete initialization of game
    super.initGame();

    // Set debug mode class
    $("body").toggleClass("debug-mode", this.debugMode);

    // TODO: Set delay to 20
    this.screensaverDelay = this.settings.screensaverDelay; // Time BEFORE user is asked to confirm presence
    this.screenRedirectDelay = this.settings.screenRedirectDelay; // Time allowed to confirm presence
    this.initScreenSaver();

    // Prepare animated texts
    this.initSpokenTexts();

    // // Animated border - check if boxes are too small, update classes
    // $.each($(".container.animated-border"), (index, el) => {
    //   const $el = $(el);
    //
    //   if ($el.outerHeight() <= 350) {
    //     $el.addClass("animated-border-small");
    //     $el.removeClass("animated-border");
    //   }
    // });


  };

  initEvents() {
    let keyMap = {};

    Object.keys(app.settings.keys).forEach(function (key) {
      if (app.settings.keys[key]) {
        keyMap[app.settings.keys[key]] = key;
      }
    });

    $(document).keydown((e) => {
      // Make sure the screensaver delay is reset when we hit a note because we are not touching the screen
      app.resetTimer();

      if (this.buttonIsLocked) {
        // console.log("App button is locked, ignore");
        return;
      }

      if (keyMap.hasOwnProperty(e.keyCode)) {
        const keyName = keyMap[e.keyCode]

        // Handle when the Yellow button is pressed
        if (["move"].includes(keyName)) {
          // If we are on the activity check screen popup, let's handle that button
          if ($("#screen-activity-check").hasClass("shown")) {
            $("#screen-activity-check").find("button").trigger("click");
          } else {
            // Handle per screen type
            let $screen = $("#screen-" + this.currentScreen);
            let screenType = $screen.data("type");

            if ($screen.find("button.pressable-button").length > 0 && (screenType === "tutorial" || screenType === "warning" || screenType === "feedback")) {
              $screen.find("button.pressable-button").trigger("click");
            }
          }
        }
      }
    });
  }

  initSpokenTexts() {
    var split = new SplitText(".spoken-text-i18n > span", {
      type: "words,chars",
      // position: "absolute"
      charsClass: "letter"
    });
  }

  // Override BaseGameMyst function to prevent scan during gameplay (screen 4)
  rfidScan(scanData) {
    if (this.currentScreen === 4) {
      scanData = null;
      this.mqtt.mostRecentVisitId = this.currentVisitorData.visit_id
    }
    super.rfidScan(scanData)
  }

  // On message received from RFID systems
  onMessage(e) {
    const type = e.type;
    const scanData = e.scanData;
    const screenType = $("#screen-" + this.currentScreen).data("type");
    const needUserSwitch = typeof scanData.userSwitch !== "undefined" && scanData.userSwitch == true;
    const baseStationRFID = this.data.base_station_rfid;
    const collectableRFIDs = this.data.collectable_rfids;
    const collectedRFIDs = {};

    // Define progress states
    const baseRFIDState = scanData.progress.find((e) => e.station === baseStationRFID).state;

    const collectedRFIDsCount = collectableRFIDs.reduce(
      (accumulator, rfid) => accumulator + (['ongoing', 'completed'].includes(scanData.progress.find((e) => e.station === rfid)?.state) ? 1 : 0),
      0,
    );

    collectableRFIDs.forEach((key) => {
      collectedRFIDs[key] = (['ongoing', 'completed'].includes(scanData.progress.find((e) => e.station === key)?.state) ? 1 : 0);
    });

    // TODO: Check how we'll handle the RFID part for that arcade game
    // Prevent screen change when screen locked
    if (!this.lockScreen && type === "rfidScan") {

      // When user scan RFID

      // Play RFID scan sound
      this.audio.play(this.data.global.sounds.rfid_scan, 1.0);

      if (needUserSwitch) {
        // The user changed so let's reset and trigger its RFID
        if (this.currentScreen > 1) {
          this.animateOutReset();

          // Reset visitor
          this.currentVisitorData = null;

          // The reset function will emit a resetComplete event so we know everything is done reseting
          $(this).one("resetComplete", () => {
            // trigger the scan again now
            // clear userSwitch flag
            scanData.userSwitch = false;
            this.rfidScan(scanData)
          });

        }
      } else {
        if (this.waitingForRFIDScan) {
          // Same user, let's see what to do
          if (screenType === "feedback") {
            // Collect reward
            this.animateOutReset();
          }

          // Update scan progression
          // NOTE: "completed" will be sent automatically from the success screen

          // const scanProgression = $("#screen-" + this.currentScreen).data("scan-progression");
          // if (scanProgression) {
          //   this.simulator.updateBaseStationState(scanProgression);
          //   this.mqtt.updateBaseStationState(scanProgression);
          // }
        } else {
          // No current user, it's a new user
          if (this.currentScreen === 1) {
            const hasSeenErik = BaseGameMyst.findStationScanData("RFID-118", scanData) === "ongoing" || BaseGameMyst.findStationScanData("RFID-118", scanData) === "completed";
            const gameAlreadyCompleted = baseRFIDState === "completed";

            if (!hasSeenErik) {
              this.animateOutIdle(this.data.content.warning[0].name.replace("screen-", ""));
            } else if (gameAlreadyCompleted) {
              this.animateOutIdle(this.data.content.warning[1].name.replace("screen-", ""));
            } else {
              this.animateOutIdle(this.data.content.initial[0].name.replace("screen-", ""));
            }

          }
        }
      }
    }

    // Reset (screensaver) timer on RFID message
    this.resetTimer();
  }

  // To be overridden in child games
  initScreen(screenId) {
    // Unlock screen
    //this.unlockCurrentScreen();

    // Super constructor
    if (super.initScreen(screenId) === false) {
      return false;
    }

    const $previousScreenEl = $("#screen-" + this.currentScreen);
    const previousScreenType = $previousScreenEl.data("type");

    const $screenEl = $("#screen-" + screenId);
    const screenName = $screenEl.data("name");
    const screenType = $screenEl.data("type");
    const mediaType = $screenEl.data("media-type");

    console.log('gotoScreen', screenId, screenName, screenType);

    // Idle
    if (screenType === "idle") {
      this.animateInIdle($screenEl);
    } else if (["tutorial", "warning", "feedback"].includes(screenType)) {
      // Intro / Instruction / Feedback (positive/negative) / Microscope
      this.animateInContent($screenEl, previousScreenType);
    } else if (screenType === "game") {
      // Game
      this.animateInGame($screenEl);
    }
  }

  /**
   * Global animate out, game reset
   */
  animateOutReset() {
    this.waitingForRFIDScan = false;

    const $screenEl = $("#screen-" + this.currentScreen);

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    this.lockAppButton();
    this.game.lockPlayerActions();
    $screenEl.removeClass("current");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // this.currentTimeline.add(() => {
    //   // animate game timeline in reverse so we get back to the original background
    //   this.game.gameTimerTimeline.tweenTo(0, {duration: 1});
    // }, '<=');


    // Pause & Hide screen saver
    this.pauseScreenSaver();
    $("#screen-activity-check").removeClass("shown");

    // Hide content
    this.currentTimeline.to($screenEl.find(".container"), {
      alpha: 0.0,
      duration: 0.85,
      ease: "power1.inOut"
    });

    this.currentTimeline.to($(".main-background-ciel.night, #game-night-overlay, #game-houses-glow-overlay"),
      {
        opacity: 0,
        duration: 0.85,
        ease: "none",
        overwrite: "auto",
      }, '<=')

    this.currentTimeline.to("#background-overlay", {
      alpha: 0.0,
      duration: 0.85,
      ease: "power1.inOut"
    }, '<=');

    if ($screenEl.find(".container-button").length) {
      this.currentTimeline.to($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0,
        duration: 0.75,
        onComplete: () => {
          // Disable button animations
          $screenEl.find("button.pulse-animation, button.up-down-animation").removeClass("play-animation");
        },
        ease: "power1.inOut"
      }, '<=');
    }

    // Hide reward
    if ($screenEl.find(".reward-image")) {
      this.currentTimeline.to($screenEl.find(".reward-image"), {
        alpha: 0.0,
        scale: 0,
        duration: 0.75,
        ease: "power1.inOut",
        onComplete: () => {
          gsap.set($screenEl.find(".reward-image"), {
            x: 0,
            y: 0,
            rotate: 0
          });
          gsap.set($screenEl.find(".reward-image img"), {
            scale: 1.0
          });
        }
      }, '<=');
    }

    // Kill ending screen timer
    if ($screenEl.find(".timer-progress")) {
      // Reset redirect timeout
      if (this.endingRedirectTimeout !== false) {
        clearTimeout(this.endingRedirectTimeout);
        this.endingRedirectTimeout = false;
      }
      this.endingScreenTimer.stopTimer();
      this.currentTimeline.to($screenEl.find(".timer-progress"), {
        alpha: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, '<=');
    }

    // Reset game
    this.currentTimeline.add(() => {
      this.reset(1);
    });
  }

  /**
   * Animate IN IDLE screen
   * @param $screenEl
   */
  animateInIdle($screenEl) {

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    this.lockCurrentScreen();
    this.lockAppButton();

    // Show background
    if (!$('.main-background.idle').hasClass("active")) {
      this.currentTimeline.to($('.main-background.idle'), {
        alpha: 1.0,
        duration: 0.75,
        ease: "power2.inOut"
      });

      $('.main-background.idle').addClass("active");
    }

    // Show background
    this.currentTimeline.fromTo($screenEl.find(".popup-container"), {
      alpha: 0.0,
    }, {
      alpha: 1.0,
      duration: 0.50,
      ease: "power1.inOut"
    });

    // Show container button
    if ($screenEl.find(".container-button").length) {
      this.currentTimeline.fromTo($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0.0
      }, {
        alpha: 1.0,
        scale: 1.0,
        duration: 0.75,
        ease: "power2.out"
      });

      // Enable button animations
      $screenEl.find("button.pulse-animation, button.up-down-animation").addClass("play-animation");
    }

    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();
    });


  }

  /**
   * Animate OUT IDLE screen
   * @param screenDestinationId
   */
  animateOutIdle(screenDestinationId) {
    const $screenEl = $("#screen-" + this.findScreenIdByAttribute("data-type", "idle"));

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    this.lockAppButton();
    $screenEl.removeClass("current");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Hide container button
    if ($screenEl.find(".container-button").length) {
      this.currentTimeline.to($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, "<=");
    }

    // Hide content
    this.currentTimeline.to($screenEl.find(".popup-container"), {
      alpha: 0.0,
      duration: 0.50,
      ease: "power1.inOut"
    });

    // Hide background
    this.currentTimeline.to($screenEl.find("#idle-background"), {
      alpha: 0.0,
      duration: 0.50,
      ease: "power1.inOut"
    });

    // End by going to new screen
    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();
      this.goToScreen(screenDestinationId);
    });
  }

  /**
   * Animate IN Content screen
   * @param $screenEl
   * @param previousScreenType
   */
  animateInContent($screenEl, previousScreenType) {
    // Build animation timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();
    // this.currentTimeline.timeScale(99999);

    // Prevent interaction with screen
    $screenEl.addClass("disabled");

    // Force reset texts states
    gsap.set($screenEl.find(".container-content .spoken-text-i18n .letter"), {
      alpha: 0,
      y: 0
    });

    const scanProgression = $screenEl.data("scan-progression");
    const setProgression = $screenEl.data("set-progression");
    const hasScanProgression = $screenEl.data("scan-progression") != false;
    const hasButtonPress = $screenEl.find("button").length;

    if (setProgression) {
      this.simulator.updateBaseStationState(setProgression);
      this.mqtt.updateBaseStationState(setProgression);
    }

    const soundToPlay = $screenEl.data("sound");
    const backgroundType = $screenEl.data("background-type");
    const screenType = $screenEl.data("type");

    if (backgroundType == "idle") {
      // If wanted background is idle and is not already shown, show it
      if (!$('.main-background.idle').hasClass("active")) {
        this.currentTimeline.to($('.main-background.idle'), {
          alpha: 1.0,
          duration: 0.75,
          ease: "power2.inOut"
        });

        $('.main-background.idle').addClass("active");
      }

    } else {
      // If we do not want the idle background and is shown, hide it
      if ($('.main-background.idle').hasClass("active")) {
        this.currentTimeline.to($('.main-background.idle'), {
          alpha: 0.0,
          duration: 0.75,
          ease: "power2.inOut"
        });

        $('.main-background.idle').removeClass("active");
      }
    }

    if (soundToPlay) {
      this.currentTimeline.add(() => {
        this.audio.play(app.data.global.sounds[soundToPlay], 1.0, true);
      });
    }

    // Show background
    const hasBackgroundOverlay = $screenEl.data("has-background-overlay");

    if (hasBackgroundOverlay) {
      this.currentTimeline.to("#background-overlay", {
        alpha: 1.0,
        duration: 0.75,
        ease: "power2.inOut"
      });
    }

    // Show content
    this.currentTimeline.fromTo($screenEl.find(".container"), {
      alpha: 0.0,
      y: -180
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.60,
      ease: "power1.inOut"
    });

    // Show container title
    if ($screenEl.find(".container-title").length) {
      this.currentTimeline.fromTo($screenEl.find(".container-title"), {
        '--title-width': "0%"
      }, {
        '--title-width': "100%",
        duration: 0.45,
        ease: "power2.out"
      });
      this.currentTimeline.fromTo($screenEl.find(".container-title-inner"), {
        alpha: 0.0
      }, {
        alpha: 1.0,
        duration: 0.30,
        ease: "power1.in"
      });
    }

    // Show container text

    // We need to animate both EN and FR letters AT THE SAME TIME and SEPARATELY as their lengths are different
    // and also if we switch language we need to have the other animation running at the same time
    // Let's create a label so we have a known timing
    this.currentTimeline.addLabel("spoken-text-in");

    let letters = [];
    letters.push($screenEl.find(`.container-content .spoken-text-i18n:not(.hidden) .en .letter`));
    letters.push($screenEl.find(`.container-content .spoken-text-i18n:not(.hidden) .fr .letter`));

    if (letters.length) {
      for (let i = 0; i < 2; i++) {
        this.currentTimeline.fromTo(letters[i], {
          alpha: 0,
          // y: "+=25%",
        }, {
          alpha: 1,
          // y: 0,
          ease: "back",
          duration: 0.02,
          stagger: 0.04
        }, "spoken-text-in");
      }
    }

    // Show container title
    if ($screenEl.find(".container-context-images").length) {
      this.currentTimeline.fromTo($screenEl.find(".container-context-images .context-image img"), {
        alpha: 0,
        y: "-=10%",
      }, {
        alpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.25
      });
    }

    // Show container button
    if ($screenEl.find(".container-button").length) {

      // Turn on lights
      if (hasScanProgression && $screenEl.find("button.pulse-animation").length > 0) {
        this.currentTimeline.add(() => {
          this.mqtt.setLight("standby")
        });
      }

      this.currentTimeline.fromTo($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0.0
      }, {
        alpha: 1.0,
        scale: 1.0,
        duration: 0.75,
        ease: "power2.out"
      });

      // Enable button animations
      $screenEl.find("button.pulse-animation, button.up-down-animation").addClass("play-animation");
    }

    if (screenType == "feedback" || screenType == "warning") {
      this.currentTimeline.set($screenEl.find(".timer-progress circle"), {
        strokeDasharray: 201.062,
        strokeDashoffset: 201.062
      });
      this.currentTimeline.fromTo($screenEl.find(".timer-progress"), {
        alpha: 0.0
      }, {
        alpha: 1.0,
        duration: 0.75,
        ease: "power1.inOut"
      });
    }

    // Enable interaction with screen
    this.currentTimeline.add(() => {
      $screenEl.removeClass("disabled");
      this.waitingForRFIDScan = hasScanProgression;

      if (hasButtonPress) {
        this.unlockAppButton();
      }

      if ((screenType == "feedback" || screenType == "warning") && $screenEl.find(".timer-progress")) {
        const timerDuration = $screenEl.data("timer-duration")

        // Reset redirect timeout and start timer
        if (this.endingRedirectTimeout !== false) {
          clearTimeout(this.endingRedirectTimeout);
          this.endingRedirectTimeout = false;
        }
        this.endingScreenTimer.startTimer(
          $screenEl.find(".timer-progress"),
          timerDuration,
          () => {
            this.animateOutReset();
          });
      }
    });
  }

  /**
   * Animate Out Content screen
   * @param screenDestinationId
   */
  animateOutContent(screenDestinationId = false) {
    const $screenEl = $("#screen-" + this.currentScreen);

    this.waitingForRFIDScan = false;

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    this.lockAppButton();
    $screenEl.removeClass("current");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();
    // this.currentTimeline.timeScale(99999);

    // Hide content
    this.currentTimeline.to($screenEl.find(".container"), {
      y: 180,
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    // Hide container button
    if ($screenEl.find(".container-button").length) {
      this.currentTimeline.to($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, "<=");
    }

    const hasBackgroundOverlay = $screenEl.data("has-background-overlay");
    const keepBackgroundOverlayOnFadeOut = $screenEl.data("keep-background-overlay-on-fade-out");

    // Hide background overlay
    if (hasBackgroundOverlay === true && keepBackgroundOverlayOnFadeOut !== true) {
      this.currentTimeline.to("#background-overlay", {
        alpha: 0.0,
        duration: 0.75,
        ease: "power2.inOut"
      });
    }

    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();

      if (screenDestinationId) {
        this.goToScreen(screenDestinationId);
      } else {
        this.goToNextScreen();
      }
    });
  }

  /**
   * Animate In Game screen
   * @param $screenEl
   */
  animateInGame($screenEl) {

    const scanProgression = $screenEl.data("scan-progression");
    const setProgression = $screenEl.data("set-progression");

    if (setProgression) {
      this.simulator.updateBaseStationState(setProgression);
      this.mqtt.updateBaseStationState(setProgression);
    }

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    this.currentTimeline.add(() => {
      this.game.beforeAnimateIn();
    }, '<=');

    // Show content
    this.currentTimeline.fromTo($screenEl.find(".game-container"), {
      alpha: 0.0,
    }, {
      alpha: 1.0,
      duration: 1,
      ease: "power3.out"
    });

    this.currentTimeline.to("#game-night-overlay .invert", {
      alpha: 0,
      duration: 1,
      ease: "power3.out"
    }, 0);

    // Animate in player

    this.currentTimeline.add(() => {
      // Play sound
      this.audio.play(this.data.global.sounds.game_start, 1.0, true);
      this.game.playerAudio.start();
    });

    this.currentTimeline.fromTo(this.game.player, {
        pixi: {
          x: 1200,
          y: 3990
        },
      },
      {
        pixi: {
          x: this.game.player.initialPosition.x,
          y: this.game.player.initialPosition.y
        },
        duration: 3,
        ease: "power1.out",
      });

    // Show content
    this.currentTimeline.fromTo($screenEl.find(".game-instructions"), {
      alpha: 0.0,
    }, {
      alpha: 1.0,
      duration: 1,
      ease: "power1.inOut"
    });

    this.currentTimeline.fromTo($screenEl.find(".game-instructions-inner"), {
      alpha: 0.0,
      y: -180
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.60,
      ease: "power3.out"
    });

    // Show container title
    if ($screenEl.find(".container-title").length) {
      this.currentTimeline.fromTo($screenEl.find(".container-title"), {
        '--title-width': "0%"
      }, {
        '--title-width': "100%",
        duration: 0.45,
        ease: "power2.out"
      });
      this.currentTimeline.fromTo($screenEl.find(".container-title-inner"), {
        alpha: 0.0
      }, {
        alpha: 1.0,
        duration: 0.30,
        ease: "power1.in"
      });
    }

    this.currentTimeline.fromTo($screenEl.find(".instructions-step[data-step='1']"), {
      alpha: 0.0,
    }, {
      alpha: 1.0,
      duration: 0.30,
      ease: "power3.out"
    }, '<=');

    this.currentTimeline.add(() => {
      this.game.player.updateTilesStatus();
      this.game.player.updateSelectTilesStatus();
    });

    this.currentTimeline.add(() => {
      this.game.begin();
    });
  }

  /**
   * Animate Out Game screen
   */
  animateOutGame(screenDestinationId = false) {
    const $screenEl = $("#screen-" + this.currentScreen);
    this.waitingForRFIDScan = false;

    this.currentTimeline.add(() => {
      this.game.beforeAnimateOut();
    }, '<=');

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    this.lockAppButton();
    $screenEl.removeClass("current");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    this.currentTimeline.fromTo($screenEl.find(".game-container"), {
      alpha: 1.0,
    }, {
      alpha: 0.0,
      duration: 1,
      ease: "power3.out"
    });

    this.currentTimeline.to("#game-night-overlay .invert", {
      alpha: 1,
      duration: 1,
      ease: "power3.out"
    }, 0);

    const hasBackgroundOverlay = $screenEl.data("has-background-overlay");
    const keepBackgroundOverlayOnFadeOut = $screenEl.data("keep-background-overlay-on-fade-out");

    // Hide background overlay
    if (hasBackgroundOverlay === true && keepBackgroundOverlayOnFadeOut !== true) {
      this.currentTimeline.to("#background-overlay", {
        alpha: 0.0,
        duration: 0.75,
        ease: "power2.inOut"
      });
    }


    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();

      if (screenDestinationId) {
        this.goToScreen(screenDestinationId);
      } else {
        this.goToNextScreen();
      }
    });
  }

  /**
   * This will display dynamic failure message, when a specific number of collectable is needed.
   * This is used mainly in Quest 1 (Lagopèdes)
   */
  updateFeedback(collectedRFIDs) {
    const $failureScreen = $(".screen[data-type='feedback'][data-feedback-type='failure']");

    if ($failureScreen.find(".progress-steps").length > 0) {
      $failureScreen.find(".progress-steps .progress-step").each((i, n) => $(n).toggleClass("completed", !!parseInt(collectedRFIDs[$(n).data("step-rfid")])));
    }
  }

  /**
   * Animate In screen saver overlay
   */
  animateInScreenSaver() {
    const $screenSaverEl = $("#screen-activity-check");
    $screenSaverEl.addClass("shown");

    // Timeline not needed for this specific case
    gsap.fromTo($screenSaverEl.find(".inner"), {
      alpha: 0.0,
      scale: 0.75
    }, {
      alpha: 1.0,
      scale: 1.0,
      duration: 0.5,
      delay: 0.20,
      ease: "power1.inOut"
    });
    gsap.fromTo($screenSaverEl.find(".opacity-container"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.25,
      delay: 0.70,
      ease: "power1.inOut",
      onComplete: () => {
        this.unlockAppButton();
      }
    });

    // Start timer
    setTimeout(() => {
      this.screenSaverTimer.startTimer($screenSaverEl.find(".timer-progress"), this.screenRedirectDelay - 0.95);
    }, 700);
  }

  /**
   * Go to screen saver
   */
  goToScreenSaver() {
    // We're already at the intro, no need to do this again
    if (this.currentScreen && this.currentScreen > 1 && !this.lockScreenSaver) {
      this.pauseScreenSaver();

      // Ask user if still there
      this.animateInScreenSaver();

      this.redirectTimeout = setTimeout(() => {
        $("#screen-activity-check").removeClass("shown");
        this.animateOutReset();
      }, this.screenRedirectDelay * 1000);
    }
  }

  /**
   * When user is asked if he's still there
   * @param stillThere
   */
  screenActivityCheck(stillThere = false) {
    if (stillThere) {
      // Return to the game
      // Reset redirect timeout
      if (this.redirectTimeout !== false) {
        clearTimeout(this.redirectTimeout);
        this.redirectTimeout = false;
      }

      $("#screen-activity-check").removeClass("shown");
      this.unpauseScreenSaver();
    } else {
      // Reset the game
      $("#screen-activity-check").removeClass("shown");
      this.animateOutReset();
    }

    // Kill screen saver timer
    this.screenSaverTimer.stopTimer();
  }

  /**
   * Return screen id using attribute and value
   * @param attribute
   * @param attributeValue
   * @returns {*|boolean}
   */
  findScreenIdByAttribute(attribute, attributeValue) {
    const elementFound = $(`.screen[${attribute}="${attributeValue}"]`).eq(0);

    if (elementFound.length) {
      return parseInt(elementFound.attr("id").replace("screen-", ""));
    } else {
      return false;
    }
  }

  /**
   * Kill/reset timeline before building a new one
   */
  killTimeline() {
    if (this.currentTimeline) {
      this.currentTimeline.kill();
      this.currentTimeline = null;
    }
  }

  // Prevent pressing on the yellow physical button when out of the game
  lockAppButton() {
    console.log("locking button");
    this.buttonIsLocked = true;
  }

  // Allow pressing on the yellow physical button when out of the game
  unlockAppButton() {
    console.log("unlocking button");
    this.buttonIsLocked = false;
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   * @returns {boolean}
   */
  reset(screenId) {
    // TODO: Reset things here
    console.log("RESET");

    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    // reset visitor
    this.waitingForRFIDScan = false;
    this.currentVisitorData = null;

    // Reset video

    // Reset interface

    // Reset variable

    // Things that reset after goToScreen
    const resetCallback = () => {
      // TODO: Reset things here

      // Reset failure screen text
      // Reset failure screen progress counter
      const $failureScreen = $(".screen[data-type='feedback'][data-feedback-type='failure']");
      if ($failureScreen.find(".progress-steps")) {
        // TODO: Change code?
        // $failureScreen.find(".container-content .spoken-text-i18n").addClass("hidden");
        $failureScreen.find(".progress-steps .progress-step").removeClass("completed");
        // $failureScreen.find(".container-content .spoken-text-i18n").eq(0).removeClass("hidden");
        // $failureScreen.find(".progress-steps .progress-step").eq(0).addClass("completed");
      }

      // Reset games
      this.game.reset();

      // Turn on lights
      this.mqtt.setLight("standby")
    }

    // Allow screen change
    this.unlockCurrentScreen();
    // Unpause screen saver timer
    this.unpauseScreenSaver();

    this.lockAppButton();

    if (typeof screenId == "undefined") {
      resetCallback();
    }

    // Super
    if (super.reset(screenId, resetCallback) === false) {
      return false;
    }
  }
}
